<div class="root-container">
    <div class="absolute top-5 right-5">
      <toggle-dark classes="text-darkgray dark:text-gray-50" />
    </div>

    <div class="form-border">
      <div class="form">
        <div class="flex flex-col items-center justify-center pb-12 text-darkgray dark:text-gray-50 title">
          <img [src]="isDark ? 'assets/images/brand-logo.png' : 'assets/images/brand-logo-black.png'" class="pb-8 max-w-44" alt="">
          <h3 class="pb-3 text-5xl">Welcome Back!</h3>
          <p class="text-base">Please enter your credentials</p>
        </div>
        <form [formGroup]="form" class="flex flex-col w-full space-y-5">
          <input type="email" formControlName="email" placeholder="email" [class]="loading() ? 'disabled' : ''" />
          <div class="relative w-full">
            <label for="password"></label>
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" [class]="loading() ? 'disabled w-full' : ' w-full'" placeholder="password" autocomplete="password" />
            <i
                (click)="showPassword = !showPassword"
                [class]="showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"
                class="absolute text-lg text-darkgray dark:text-lightgray top-2 right-3"
            ></i>
          </div>

          <div class="min-h-5">
            <span class="text-sm text-red-500">{{ error ? error : '' }}</span>
          </div>

          <div class="mx-auto">
            <button class="!px-10 main-btn" [ngClass]="{disabled: loading()}" (click)="submit()">
              @if(!loading()){
                <span>Log in</span>
              }@else {
                <div class="mb-1">
                  <spinner [size]="17" />
                </div>
              }
            </button>
          </div>
        </form>
      </div>
    </div>
</div>
